import { useCasinoSettings } from '../useCasinoSettings';
import { useLoadCasinoFeed } from '../useLoadCasinoFeed';

export const useLoadCasinoCollectionData = ({ casinoType, condition }) => {
  const { collectionFeed: feedNames } = useCasinoSettings(casinoType);

  useLoadCasinoFeed({ feedNames, condition });
};
